import React, { useEffect, useRef, useState } from 'react'
import { trans } from '../../_providers/Translation'
import loader from '../../assets/img/loader.svg'
import { useAuthDataContext } from '../../_providers/Auth'
import { usePaymentMethodIcon } from '../../_helpers/usePaymentMethodIcon'
import InvoiceOptions from './InvoiceOptions'
import InvoicePayment from './InvoicePayment'
import InvoicePaymentMethodMenu from './InvoicePaymentMethodMenu'
import Api from '../../_helpers/Api'
import Success from '../modals/messages/Success'
import Question from '../modals/messages/Question'
import { Link } from 'react-router-dom'
import notFound from '../../assets/img/not-found.png'

// images
import applyIcon from "@/assets/img/reservations/icons/check.svg"
import { Checkbox, Tooltip } from '@mui/material'
import NoDataFound from './NoDataFound'
import Skeleton from 'react-loading-skeleton'

function InvoicesTable(props) {

    const auth = useAuthDataContext()
    const getMethodIcon = usePaymentMethodIcon({ width: 17, height: 17, flexShrink: 0, objectFit: 'contain' })

    const [paymentMethods, setPaymentMethods] = useState([])

    useEffect(() => {
        Api.get('payments/methods')
            .then(res => {
                setPaymentMethods(res.data)
            })
    }, [])

    const selectRef = useRef(null)
    const successSendModalRef = useRef(null)
    const questionModalRef = useRef(null)
    const paymentModalRef = useRef(null)

    const handleAction = () => {
        let action = selectRef.current.value
        let selected = []

        document.querySelectorAll('.selected:checked').forEach(el => {
            selected.push(Number(el.value))
        })

        let question = questionModalRef.current

        switch (action) {
            case 'send':
                question.open()
                question.onSuccess(() => {
                    send(selected)
                })
                break
            case 'mark-as-paid':
                markAsPaid(selected)
                break
            case 'mark-as-unpaid':
                question.open()
                question.onSuccess(() => {
                    markAsUnpaid(selected)
                })
                break
        }
    }

    const send = ids => {
        Api.post('invoices/send', {
            ids: ids,
        }).then(() => {
            let modal = successSendModalRef.current

            modal.open()
            modal.onClose(() => {
                if (typeof props.refreshData === 'function') {
                    props.refreshData()
                }
            })
        })
    }

    const markAsPaid = ids => {
        let modal = paymentModalRef.current

        modal.open(ids)
        modal.onSuccess(() => {
            let modal = successSendModalRef.current

            modal.open()
            modal.onClose(() => {
                if (typeof props.refreshData === 'function') {
                    props.refreshData()
                }
            })
        })
    }

    const markAsUnpaid = ids => {
        Api.post('invoices/mark-as-unpaid', {
            id: ids,
        }).then(() => {
            let modal = successSendModalRef.current

            modal.open()
            modal.onClose(() => {
                if (typeof props.refreshData === 'function') {
                    props.refreshData()
                }
            })
        })
    }

    return (
        <>
            <Question
                ref={questionModalRef}
                mainMessage={trans('headings.question15')}
            />

            <Success
                ref={successSendModalRef}
                mainMessage={trans('messages.success')}
            />

            <InvoicePayment
                ref={paymentModalRef}
            />
            {props.loading ?
                <Skeleton height={45} count={10} />
                :
                props.invoices.length === 0 ?
                    <NoDataFound />
                    :
                    <>
                        <div className="table-scroller">
                            <table className="invoices">
                                <thead>
                                    <tr>
                                        <th style={{
                                            width: '20px'
                                        }}></th>
                                        <th>{`№/${trans('tables.date')}`}</th>
                                        <th>{trans('tables.type')}</th>
                                        <th>{trans('tables.client')}</th>
                                        {props.showReservation &&
                                            <>
                                                <th>{trans('tables.reservation')}</th>
                                            </>
                                        }
                                        <th className="right">{trans('tables.netPrice')}</th>
                                        <th className="right">{trans('tables.tax')}</th>
                                        <th className="right">{trans('tables.gross')}</th>
                                        <th className="todo-check">{trans('tables.paid')}</th>
                                        {props.canModify &&
                                            <th className="options">{trans('tables.options')}</th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.invoices.map(each =>
                                        <tr
                                            key={each.id}
                                            onClick={() => window.open(each.signed_url, '_blank')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <td
                                                style={{
                                                    width: '20px'
                                                }}
                                                onClick={e => e.stopPropagation()}
                                            >
                                                <Checkbox
                                                    name="selected[]"
                                                    value={each.id}
                                                    size='small'
                                                    slotProps={{ input: { className: 'selected' } }}
                                                />
                                            </td>
                                            <td>{`${each.no} / ${each.date_dmy}`}</td>
                                            <td>

                                                {each.type}
                                            </td>
                                            <td>

                                                {each.direction === 1
                                                    ?
                                                    each.customer?.full_name || each.client?.full_name
                                                    :
                                                    each.direction === 2
                                                        ?
                                                        <Link to={'/relationships/' + each.customer?.id} onClick={e => e.stopPropagation()}>
                                                            {each.customer?.full_name}
                                                        </Link>
                                                        :
                                                        each.direction === 3
                                                            ?
                                                            each.client?.full_name
                                                            :
                                                            each.client?.full_name

                                                }
                                            </td>
                                            {props.showReservation &&
                                                <>
                                                    <td>
                                                        {each.reservation
                                                            ?
                                                            <Link
                                                                to={'/schedule/reservations/edit/' + each.reservation_id}
                                                                onClick={e => e.stopPropagation()}
                                                            // className="btn"
                                                            // style={{ background: each.reservation.color, color: each.reservation.text_color }}
                                                            >
                                                                {each.reservation.reference_code}
                                                            </Link>
                                                            :
                                                            ''
                                                        }
                                                    </td>
                                                </>
                                            }
                                            <td className="right">
                                                {each.net_price_formatted} {each.currency && each.currency.name}
                                            </td>
                                            <td className="right">{each.vat_price_formatted} {each.currency && each.currency.name}</td>
                                            <td className="right"><b>{each.total_gross_price_formatted} {each.currency && each.currency.name}</b></td>
                                            <td>
                                                {each.is_paid
                                                    ?
                                                    <Tooltip title={each.paid_at_dmy} followCursor>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            {getMethodIcon(each.paymentmethod)}
                                                            {each.paymentmethod
                                                                ?
                                                                each.paymentmethod.translation ? each.paymentmethod.translation.name : each.paymentmethod.name
                                                                :
                                                                ''
                                                            }
                                                        </div>
                                                    </Tooltip>
                                                    :
                                                    <InvoicePaymentMethodMenu
                                                        invoice={each}
                                                        methods={paymentMethods}
                                                        refreshData={props.refreshData}
                                                    />}
                                            </td>
                                            {props.canModify &&
                                                <td className="options" onClick={e => e.stopPropagation()}>
                                                    <InvoiceOptions
                                                        invoice={each}
                                                        refreshData={props.refreshData}
                                                        handleDelete={props.handleDelete}
                                                    />
                                                </td>
                                            }
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                        </div>

                        <hr />
                        {props.canModify &&
                            <div
                                className="row"
                                style={{
                                    gap: "10px",
                                    alignItems: "center"
                                }}
                            >
                                <select
                                    ref={selectRef}
                                >
                                    <option value="send">
                                        {trans('random.sentToClien')}
                                    </option>
                                    {props.showPaidAll &&
                                        <option value="mark-as-paid">
                                            {trans('random.markAllAsPaid')}
                                        </option>
                                    }
                                    {props.showUnpaidAll &&
                                        <option value="mark-as-unpaid">
                                            {trans('random.markAllAsUnpaid')}
                                        </option>
                                    }
                                    {props.showAwaitingAll &&
                                        <option value="mark-as-paid">
                                            {trans('random.markAllAsPaid')}
                                        </option>
                                    }
                                </select>
                                <button
                                    onClick={handleAction}
                                    className='button button-small button-default'
                                >
                                    <img src={applyIcon} alt="apply" />
                                    {trans('buttons.applyForSelected')}
                                </button>
                            </div>
                        }
                    </>

            }
        </>
    )
}

export default InvoicesTable